import { useEffect, useRef, useState } from "react";
import useBreakpoint from "./useBreakpoint";

// dimensione header
const MOBILE_HEADER_SIZE = 88;
// dimensione header + spazio + 2 px di tolleranza
const SPACE = 16;
const MOBILE_STICKY_CHECK = MOBILE_HEADER_SIZE + SPACE + 2;

const useDetectSticky = (mount, setOpen) => {
  const [isSticky, setIsSticky] = useState(false);
  const isMobile = useBreakpoint(771);

  const ref = useRef();
  useEffect(() => {
    if (!mount || !ref.current || !isMobile) {
      return;
    }
    const observer = new IntersectionObserver(
      ([e]) => {
        const isSticky =
          e.intersectionRatio < 1 && e.boundingClientRect.y < MOBILE_STICKY_CHECK + 1;
        setIsSticky(isSticky);
        if (isSticky) {
          const scrollY = window.scrollY;
          setOpen((isOpen) => {
            isOpen &&
              requestAnimationFrame(() => {
                window.scrollTo({ top: scrollY, behavior: "instant" });
              });
            return false;
          });
        }
      },
      {
        threshold: [1],
        rootMargin: `-${MOBILE_STICKY_CHECK}px 0px 0px 0px`,
      }
    );

    observer.observe(ref.current);
  }, [mount, setOpen, isMobile]);
  return [isSticky, ref];
};
export default useDetectSticky;
